<div class="container">
    <div [class]="'uploader_input ' + claseUploader">
        <div>
            <input #file1 type="file" id="fileInput" [multiple]="multiple" (change)="selectFile($event)"
                   name="fileInput"
                   hidden="hidden" [accept]="archivosSoportados"/>
        </div>
        <mat-toolbar *ngIf="progress > 0 && progress < 100" class="progress-bar">
            <mat-progress-bar color="primary" [value]="progress"></mat-progress-bar>
            <span class="progress">{{ progress }}% - {{ progressType }}</span>
        </mat-toolbar>
        <mat-progress-bar mode="indeterminate" color="primary"
                          *ngIf="seleccionando && progress === 100"></mat-progress-bar>
        <div class="archivos" (drop)="dropEvent($event)" (dragover)="onDragOver($event)" *ngIf="!isInput">
            <mat-card>
                <div class="header">
                    <h3 *ngIf="multiple">Total {{ listaArchivos ? listaArchivos.length.toString() : '' }} archivos</h3>
                    <h3 *ngIf="!multiple"></h3>
                    <button mat-raised-button color="primary" (click)="file1.click()"
                            *ngIf="!disableButton">{{ buttonName }}
                    </button>
                </div>
                <mat-card-content *ngIf="!listaArchivos || listaArchivos.length === 0">
                    <div class="items_margin"
                         *ngIf="modelType && (modelType.name === 'ArchivoIntraoral' || modelType.name === 'ArchivoBlender')">
                        Arrastra el
                        fichero aquí
                    </div>
                    <div class="items_margin" *ngIf="modelType && modelType.name === 'ArchivoSTL'"><i>Ten en cuenta que
                        sólo
                        podrás subir archivos de tipo STL o ZIP</i></div>
                    <div class="items_margin" *ngIf="modelType && modelType.name === 'ArchivoBlender'"><i>Ten en cuenta
                        que
                        sólo
                        podrás subir archivos de tipo STL</i></div>
                    <div class="items_margin" *ngIf="modelType && modelType.name === 'ArchivoIntraoral'"><i>Ten en
                        cuenta que sólo podrás subir archivos de tipo STL, PLY, OBJ o ZIP</i></div>
                </mat-card-content>
                <mat-card-content *ngIf="listaArchivos && listaArchivos.length > 0">
                    <div #lineaArchivo class="linea_archivo items_margin"
                         *ngFor="let archivo of listaArchivos; let i = index"
                         [class.seleccionado]="archivoSeleccionado && archivoSeleccionado.id === archivo.id"
                         [class.seleccionando]="archivo === archivoSiguiente">
                        <div class="titulo" (click)="click(archivo)">{{ nombreFichero(archivo) }}
                        </div>
                        <div>
                            <button mat-icon-button (click)="descargar(archivo, i)"
                                    *ngIf="puedeDescargar(archivo)">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button mat-icon-button *ngIf="puedeEliminar(archivo)" (click)="borrar(archivo, i)">
                                <mat-icon>delete_forever</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-content>
                    <div class="mat-error">{{ message }}</div>
                </mat-card-content>
                <!--                <mat-card-actions *ngIf="listaArchivos && listaArchivos.length > 0 && !disableButton">-->
                <!--                    <button mat-raised-button color="warn" (click)="borrarTodos()">Borrar todos-->
                <!--                        <mat-icon>delete_forever</mat-icon>-->
                <!--                    </button>-->
                <!--                </mat-card-actions>-->
            </mat-card>
        </div>
        <div *ngIf="isInput && (!listaArchivos || listaArchivos.length === 0)" class="field">
            <div class="dialog-cell field-name">
                <label [attr.for]="property.name">{{ property.name }}</label>
            </div>
            <div class="dialog-cell field-value" [formGroup]="formGroup">
                <mat-form-field>
                    <input matInput type="text" [formControlName]="controlName" (click)="file1.click()">
                    <button matSuffix mat-icon-button [matTooltip]="buttonName" (click)="file1.click()">
                        <mat-icon>attach_file_add</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="isInput && listaArchivos && listaArchivos.length > 0" class="field">
            <div class="dialog-cell field-name">{{ property.name }}</div>
            <div class="dialog-cell field-value"
                 *ngFor="let archivo of listaArchivos; let i = index" (click)="click(archivo)"
                 [class.seleccionado]="archivoSeleccionado && archivoSeleccionado.id === archivo.id"
                 [class.seleccionando]="archivo === archivoSiguiente">
                <div>{{ nombreFichero(archivo) }}
                </div>
                <div>
                    <button mat-icon-button (click)="descargar(archivo, i)"
                            *ngIf="puedeDescargar(archivo)">
                        <mat-icon>download</mat-icon>
                    </button>
                    <button mat-icon-button (click)="borrar(archivo, i)"
                            *ngIf="puedeEliminar(archivo)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="visor" *ngIf="mostrarVisor && !isInput">
        <div class="objViewer" #objViewer></div>
    </div>
</div>
